import { render, staticRenderFns } from "./FullscreenPhotoViewer.vue?vue&type=template&id=0dc115d6&scoped=true&"
import script from "./FullscreenPhotoViewer.vue?vue&type=script&lang=ts&"
export * from "./FullscreenPhotoViewer.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenPhotoViewer.vue?vue&type=style&index=0&id=0dc115d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc115d6",
  null
  
)

export default component.exports